export var UnitType;
(function (UnitType) {
    UnitType["Time"] = "time";
    UnitType["Byte"] = "byte";
    UnitType["Bibyte"] = "bibyte";
    UnitType["BitRate"] = "bitRate";
    UnitType["ByteRate"] = "byteRate";
})(UnitType || (UnitType = {}));
//# sourceMappingURL=interface.js.map